import React from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';
import Loader from '../../components/Loader';

const Pagination = ({
  paginationDetails,
  currentPage,
  onPageChange,
  isPaginationLoading,
}) => {
  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    onPageChange(selectedPage);
  };

  if (!paginationDetails || paginationDetails.totalElements === 0) {
    return null;
  }

  const getPageRangeDisplayed = () => {
    const totalPages = paginationDetails.totalPages;
    if (totalPages <= 7) {
      return totalPages;
    }
    
    return 7;
  };

  return (
    <PaginationContainer>
      {isPaginationLoading && (
          <Loader />
      )}
      <PaginationWrapper>
        <StyledReactPaginate
          previousLabel="‹"
          nextLabel="›"
          breakLabel="..."
          pageCount={paginationDetails.totalPages}
          marginPagesDisplayed={1}
          pageRangeDisplayed={getPageRangeDisplayed()}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          activeClassName="active"
          disabledClassName="disabled"
          forcePage={currentPage}
          isPaginationLoading={isPaginationLoading}
          pointerEvents={isPaginationLoading ? 'none' : 'auto'}
        />
      </PaginationWrapper>
    </PaginationContainer>
  );
};

export default Pagination;

const PaginationContainer = styled.div`
  position: relative;
  padding: 20px;
  background-color: #ffffff;
`;

const PaginationWrapper = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
`;

const StyledReactPaginate = styled(ReactPaginate)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: nowrap;
  list-style: none;
  margin: 0;
  padding: 0;
  transition: opacity 0.3s ease;
  pointer-events: ${props => props.pointerEvents || 'auto'};
  opacity: ${props => props.isPaginationLoading ? 0.6 : 1};

  .page-item {
    display: flex;
    flex-shrink: 0;
  }

  .page-link {
    padding: 10px 16px;
    background-color: #ffffff;
    color: #475569;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    cursor: ${props => props.isPaginationLoading ? 'not-allowed' : 'pointer'};
    font-weight: 500;
    font-size: 14px;
    font-family: var(--font-family-ibm_plex_sans);
    transition: all 0.2s ease;
    min-width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;

    &:hover {
      background-color: ${props => props.isPaginationLoading ? '#ffffff' : '#f8fafc'};
      border-color: ${props => props.isPaginationLoading ? '#e2e8f0' : '#cbd5e1'};
    }
  }

  .page-item.active .page-link {
    background-color: #7200e0;
    color: #ffffff;
    border-color: #7200e0;
    font-weight: 600;

    &:hover {
      background-color: #7200e0;
      border-color: #7200e0;
    }
  }

  .page-item.disabled .page-link {
    background-color: #f8fafc;
    color: #94a3b8;
    cursor: not-allowed;

    &:hover {
      background-color: #f8fafc;
      border-color: #e2e8f0;
    }
  }
`;